import Extend from 'flarum/common/extenders';
import commonExtend from '../common/extend';
import Post from 'flarum/common/models/Post';
import User from 'flarum/common/models/User';
export default [...commonExtend, new Extend.Model(Post) //
.attribute('canBanIP').attribute('ipAddress').hasOne('banned_ip'), new Extend.Model(User) //
.attribute('canBanIP').attribute('isBanned')];